import apiService from '../../../share/util/api/service';
import { executePolling } from '../../../share/util/api/polling';
import { VEHICLE_INFO_GET, VEHICLE_UPDATE_COMMUNICATION, VEHICLE_UPDATE_PART } from './constants';
import { executeSyncRequest } from '../../../share/util/api/syncRequest';

/**
 * カスタマイズ: カスタマイズデータ読み出しポーリング実行
 * @param {object} root 呼び出し元
 * @param {string} systemName システム名
 * @param {object} bodyParam POST時に設定するリクエストBody
 * @param {string[]?} bodyParam.system_name システム名リスト(全カスタマイズの時のみ使用)
 * @returns {Promise<object?>} 実行結果
 */
export const readCustomizeTable = async (root, systemName, bodyParam) =>
  await executePolling(
    root,
    // POST API 呼び出しのコールバック
    async () => await apiService.postCall(
      apiService.CST,
      `/netApps/${root.netAppId}/systems/${systemName}/readOutSettings`,
      bodyParam
    ),
    // GET API 呼び出しのコールバック
    async (postApiResponse) => await apiService.getCall(
      apiService.CST,
      `/netApps/${root.netAppId}/systems/${systemName}/customize/requests/${postApiResponse.data.request_id}`
    ),
    // エラー発生のコールバック
    (errorType) => { errorType; root.showUnexpectedError(VEHICLE_INFO_GET); },
    // POST API レスポンスチェックのコールバックはデフォルト処理を使用
    undefined,
    // GET API レスポンスチェックのコールバックはデフォルト処理を使用
    undefined,
    // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
    (result) => { root.validateErrorResult(result, VEHICLE_INFO_GET); },
    // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
    (result) => { root.validateErrorResult(result, VEHICLE_INFO_GET); },
  );

/**
 * カスタマイズ: カスタマイズ一覧取得
 * @param {object} root 呼び出し元
 * @param {string} projectId プロジェクトID
 * @param {string} measureId 計測データID
 * @returns {Promise<object?>} 実行結果
 */
export const getCustomizeList = async (root, projectId, measureId) =>
  await executeSyncRequest(
    root,
    async () => {
      return await apiService.getCall(
        apiService.CST,
        `/customize/${projectId}/${measureId}`,
        root.operationScreen
      );
    },
    // エラー発生のコールバック
    (errorType) => { errorType; root.showUnexpectedError(VEHICLE_INFO_GET); },
    // GET API で正常レスポンスが返ってきた際の内容チェックはデフォルト処理を利用
    undefined,
    // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する
    (result) => { root.validateErrorResult(result, VEHICLE_INFO_GET); },
  );

/**
 * 取得したカスタマイズ情報のエラーチェックを行う
 * @param {object[]} エラーチェック対象のカスタマイズ情報リスト
 * @returns {string?} 成功: null, 失敗: エラータイプ
 */
export const checkCstmListItem = (items) => {
  let errorType = null;
  const isShowConnectedErrorDialog = items.find((cstm) => cstm.showConnectedErrorDialog);
  const isShowFailedDialog = items.find((cstm) => cstm.showFailedDialog);
  // 一つでも「通信不能」を含む場合、通信エラーを表示する
  if (isShowConnectedErrorDialog) {
    errorType = VEHICLE_UPDATE_COMMUNICATION;
    // 一つも「通信不能」が無く、結果に失敗が含まれる場合、専用の書き込みエラーダイアログを表示
  } else if (isShowFailedDialog) {
    errorType = VEHICLE_UPDATE_PART;
  }
  return errorType;
};

export default {
  readCustomizeTable,
  getCustomizeList,
  checkCstmListItem,
};